import { render, staticRenderFns } from "./gl-risk-badge.vue?vue&type=template&id=731d6f68"
import script from "./gl-risk-badge.vue?vue&type=script&lang=js"
export * from "./gl-risk-badge.vue?vue&type=script&lang=js"
import style0 from "./gl-risk-badge.vue?vue&type=style&index=0&id=731d6f68&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports